/**
 * A helper class that will ensure a real boolean value is returned
 * Look at BooleanUtil.spec.ts to see how this class is used.
 */
export class BooleanUtil {
  /**
   * ensureBoolValue does what it says; no matter the input, a boolean true or false is returned.
   * This simplifies code checks.
   * The text value is always converted to string.
   * This function is null-ref safe.
   * @param value The value that you want to convert to a boolean. This can be null, undefined, or any other object.
   * @param defaultValue This value will be returned when the value is null or undefined.
   *
   * @example
   * const result = BooleanUtil.ensureBoolValue('true'); // true
   * @example
   * const result = StringUtil.SafeValue(null); // false
   * @example
   * const result = StringUtil.SafeValue('1'); // true
   */
  public static ensureBoolValue(
    value: any,
    defaultValue: boolean = false
  ): boolean {
    const truthy: Array<string> = ['true', 'True', '1'];

    if (value === undefined || value === null) {
      return defaultValue;
    }
    
    // explicitly check whether we can interpret the string as true
    return truthy.includes(value.toString());
  }
}
